import { Link } from "react-router-dom";
import { useI18n } from "@/i18n/I18nProvider";
import LangSwitch from "./LangSwitch";
import SiteSwitch from "./SiteSwitch";
import ThemeToggle from "./ThemeToggle";

const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

export default function Nav() {
    const { t } = useI18n();
    return (
        <nav
            data-testid="itly-nav"
            className="itly-nav"
            style={{
                position: "sticky",
                top: 0,
                zIndex: 40,
                width: "100%",
            }}
        >
            <div
                className="itly-nav-inner"
                style={{
                    maxWidth: 1280,
                    margin: "0 auto",
                    padding: "18px 32px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    gap: 24,
                }}
            >
                <div className="itly-nav-logo-group" style={{ display: "flex", alignItems: "center", gap: 18 }}>
                <Link
                    to="/partner"
                    onClick={scrollTop}
                    data-testid="itly-logo"
                    aria-label={t("logo.backToTop")}
                    className="itly-logo-link"
                    style={{
                        display: "inline-flex",
                        alignItems: "center",
                        gap: 12,
                        textDecoration: "none",
                    }}
                >
                    <img
                        src="/assets/itly/logo-partner.png"
                        alt="ITLY HUB"
                        data-testid="itly-logo-img"
                        style={{
                            width: 44,
                            height: 44,
                            borderRadius: 12,
                            objectFit: "contain",
                            objectPosition: "center",
                            display: "block",
                            background: "#B4C3CA",
                        }}
                    />
                    <span className="itly-wordmark">
                        ITLY <span style={{ color: "var(--itly-muted)", fontWeight: 500 }}>HUB</span>
                    </span>
                </Link>
                <span className="itly-siteswitch-desktop"><SiteSwitch /></span>
                </div>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 24,
                    }}
                    className="itly-nav-links"
                >
                    <a href="#visione" className="itly-nav-link" data-testid="nav-visione">
                        {t("nav.manifesto")}
                    </a>
                    <a href="#perche" className="itly-nav-link" data-testid="nav-perche">
                        {t("nav.why")}
                    </a>
                    <a href="#come-funziona" className="itly-nav-link" data-testid="nav-come-funziona">
                        {t("nav.howItWorks")}
                    </a>
                    <a href="#per-chi" className="itly-nav-link" data-testid="nav-per-chi">
                        {t("nav.forWho")}
                    </a>
                    <a href="#faq" className="itly-nav-link" data-testid="nav-faq">
                        {t("nav.faq")}
                    </a>
                </div>

                <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
                    <span className="itly-lang-desktop-only" style={{ display: "inline-flex", alignItems: "center", gap: 10 }}>
                        <ThemeToggle />
                        <LangSwitch />
                    </span>
                    <a
                        href="#candidati"
                        data-testid="nav-cta-apply"
                        className="itly-btn-primary itly-cta-glow"
                        style={{ padding: "10px 18px", fontSize: 14 }}
                    >
                        {t("nav.ctaApply")}
                        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round">
                            <path d="M5 12h14" />
                            <path d="m12 5 7 7-7 7" />
                        </svg>
                    </a>
                </div>
            </div>
            {/* Mobile-only second row: site switch (left) · theme + language (right) */}
            <div className="itly-nav-subrow" data-testid="nav-subrow">
                <SiteSwitch />
                <span style={{ display: "inline-flex", alignItems: "center", gap: 8, flexShrink: 0 }}>
                    <ThemeToggle />
                    <LangSwitch compact />
                </span>
            </div>
        </nav>
    );
}
